import {useState} from 'react';


//STYLES
import "./StatTab.css";

function StatTab({record}) {

    const dateToFormatYYYY = (theDate) => {
        theDate = new Date(theDate.toString().split('GMT')[0]+' UTC').toISOString().split('T')[0];
        return theDate;
    }
    const usToFrFormat = (usFormat) => {
        let datePart = usFormat.match(/\d+/g),
        year = datePart[0].substring(2),
        month = datePart[1], day = datePart[2];
        return day+'/'+month+'/'+year;
    }
    
    const secondsToHms = (d) => {
        d = Number(d/1000);
        let h = Math.floor(d / 3600);
        let m = Math.floor(d % 3600 / 60);
        //let s = Math.floor(d % 3600 % 60);

        let hDisplay = h > 0 ? h + (h === 1 ? " h " : " h ") : "";
        let mDisplay = m > 0 ? m + (m === 1 ? " min" : " min") : "";
        //let sDisplay = s > 0 ? s + (s === 1 ? "s" : "s") : "";
        return hDisplay + mDisplay;
    }

    const intensityLook = (intensity) => {
        switch (intensity) {
        case '1':
            return (
            <span className="intensityInputWrap intensity01"></span>
            );
        case '2':
            return (
            <span className="intensityInputWrap intensity02"></span>
            );
        case '3':
            return (
            <span className="intensityInputWrap intensity03"></span>
            );
        case '4':
            return (
            <span className="intensityInputWrap intensity04"></span>
            );
        case '5':
            return (
            <span className="intensityInputWrap intensity05"></span>
            );
            default:
            return (
                <span className="intensityInputWrap intensity03"></span>
            )
        }
    }

  return (
    <li className="elemStatRecord">
        <header>
            <p>{intensityLook(record.intensity)}</p>
            <p><span className="lineLabel">Date : </span><span>{usToFrFormat(dateToFormatYYYY(new Date(record.startTime)))}</span></p>
        </header>
        <div className='elemContent openTab'>
            <div className="mb10"><p><span className="lineLabel">Debut : </span><span>{(new Date(record.startTime).toLocaleTimeString()).substring(0, 5).replace(':', ' h ')}</span></p></div>
            <div className="mb10"><p><span className="lineLabel">Duree : </span><span>{secondsToHms(record.duration)}</span></p></div>
            <p className="intensity"><span className="lineLabel">Intensite : </span><span>{record.intensity}</span></p>
            <div className="medoc"><span className="lineLabel">Medicament(s) :</span>{
            record.drugs.map((drug, index)=>
                {
                    if (drug.num != 0)
                    return(
                        <span className="drugTag" key={index}><span>{drug.num}</span> <span>{drug.drug.name}</span></span>
                    )
                    else
                    return(<span key={index}>Aucun</span>)
                }
            )
            }</div>
            <div className="zones mb10"><span className="lineLabel">{record.zones > 1 ? 'Zone' : 'Zones'} :</span><span>{
                record.zones.join(', ')
            }</span></div>
            <p className="infos"><span className="lineLabel">Infos : </span><span>{record.infos ? record.infos : 'Aucune info'}</span></p>
        </div>
    </li>
  )
}

export default StatTab
